import React, { useEffect, useState } from 'react';
import TermLengths from './FullUWCoverageLengths';
import AboutData from './AboutData';
import ProductSpecificationsData from './ProductSpecificationsData';
import MarketingData from './MarketingData';
import PurchasingProcessData from './PurchasingProcessData';
import FaqData from './FaqData';
import PreQuote from '../../../../Quoters/PreQuote/PreQuote';
import { getPrimaryColor } from '../../../../Quoters/Common/Helpers/Utility';

export default function DigitalTermData() {
  const minAge = 18;
  const maxAge = 70;
  const minCoverageAmount = 100000;
  const maxCoverageAmount = 10000000;
  const primaryBrandColor = getPrimaryColor();

  return {
    name: 'Term Life Insurance',
    subtitle: 'Click. Quote. Coverage.',
    footerMessage: "Get term insurance from start to finish completely online.",
    specs: {
      age: { min: minAge, max: maxAge },
      coverageAmount: { min: minCoverageAmount, max: maxCoverageAmount },
    },
    basicInfoForm: () => {
      return <PreQuote
        landing
        brandTheme={primaryBrandColor}
        generalSpecs={
          {
            specs: {
              age: {
                min: minAge,
                max: maxAge,
              },
            }
          }}
      />;
    },
    about: AboutData(),
    productSpecifications: ProductSpecificationsData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, TermLengths()),
    marketing: MarketingData(),
    purchasingProcess: PurchasingProcessData(),
    articleKeys: [1, 2, 3],
    faq: FaqData()
  }
}
